import { Link } from 'react-router-dom'
import './GigListContainer.scss'
import Gig from '../../../../Models/Gig'
import EmptyState from '../EmptyState/EmptyState'
import { formatCurrencyIndian } from '../../../../utils/MoneyConversionUtils'


interface GigCardPropsInterface {
  gig: Gig
}

export const GigCard = ({ gig }: GigCardPropsInterface) => {

  return (
    <Link to={"/gig/" + gig.id} className='gigCard-link'>
    <div className="gigCard">
      <div className="gigCard-img">
        <img src={gig.coverImg} alt="" />
      </div>
      <div className="gigCard-content">

        {/* === SELLER === */}
        <div className='gig-freelancer'>
          <div className="imgBox">
            <img src={gig.seller.profileImage} alt="freelancer" />
          </div>
          <p>{gig.seller.fullName}</p>
        </div>

        {/* ==== TITLE ==== */}
        <p className='gig-title multi-line-truncate'>{gig.title}</p>

        {/* === PRICE === */}
        <div className='gig-price'>
          <div className="badge">
            <i className="fa-solid fa-star"></i>
            {gig.rating}
          </div>
          <div className="price">
            Starts from <span>{formatCurrencyIndian(gig.minPrice * 100)}</span>
          </div>
        </div>
      </div>
    </div>
    </Link>
  )
}

interface GigListContainerPropsInterface {
  gigList: Gig[]
}

export const GigListContainer = ({ gigList }: GigListContainerPropsInterface) => {

  // Show empty state if no gigs
  if (gigList.length === 0) {
    return <EmptyState />
  }

  return (
    <section className='gigListSection'>
      {gigList.map((gig: Gig) => <GigCard key={gig.id} gig={gig} />)}
    </section>
  )
}

export default GigListContainer